import React, { useState, useEffect, useRef } from "react";

import {
  destroyKasms,
  getUserKasms,
  createKasms,
  getStatusKasms,
  execKasm,
  updateKeepalive,
  getUserImages,
  getUserDefaultImage,
  startKasms,
} from "../../actions/actionDashboard";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { LaunchForm, checkRequiredSectionsAgainstLocal, localLaunchSelections } from "../../components/Form/LaunchForm";
import { getLoginSettings } from "../../actions/actionLogin";
import { set } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/pro-light-svg-icons";
import { EgressForm } from "../../components/Form/EgressForm";
import { KasmIcon } from "../User/UserDashboard/ListKasms";
import { Modal } from "../../components/Form/Modal";
import { useTranslation } from "react-i18next";
import { LaunchModal } from "../../components/Form/LaunchModal";

export default function Workspace(props) {
  const dispatch = useDispatch()
  const { t } = useTranslation('common');
  const liveKasms = useSelector(state => state.dashboard.liveKasms) || null
  const availableKasms = useSelector(state => state.dashboard.availableKasms) || null
  const createdKasms = useSelector(state => state.dashboard.createdKasms) || null
  const launchSelections = useSelector(state => state.images.launchSelections) || null
  
  const login_settings = useSelector(state => state.auth.login_settings) || null

  const [doLogin, setDoLogin] = useState(false);
  const [doLaunch, setDoLaunch] = useState(false);
  const [checkForm, setCheckForm] = useState(false);
  const [kasmId, setKasmId] = useState(null);
  const [status, setStatus] = useState(null);
  const [runningImage, setRunningImage] = useState(null);
  const [image, setImage] = useState(null);
  const [gatewayId, setGatewayId] = useState(null);

  let workspace_id = props.match.params.id.replaceAll('-', '');
  let sessiontype = props.match.params.type;
  let castkey = props.match.params.key;

  const createWorkspace = async () => {
    if (sessiontype === 'cast') {
      props.history.push('/cast/' + castkey);
    } else {
      try {
        let details = {
          image_id: workspace_id,
          x_res: window.innerWidth,
          y_res: window.innerHeight,
          launch_selections: launchSelections,
          persistent_profile_mode: window.localStorage.getItem("persistent_profile_mode" + workspace_id) || 'Enabled',
        }
        if (checkForm !== false) {
          details['egress_gateway_id'] = gatewayId
        }
        const workspace = await dispatch(createKasms(details))

        if (workspace.response?.error_message == 'launch_config_required' ) {
          setCheckForm(true)
          setDoLaunch(true)
        }
      } catch (e) {
        console.log(e)
      }
    }
  }

  const checkLoggedIn = async () => {
    try {
      await dispatch(getUserImages())
      await dispatch(getUserKasms())
    } catch (e) {
      if (sessiontype === 'cast') {
        const redirect = pwaDetails()
        props.history.push('/cast/' + castkey + '?redirect=' + redirect.replace('#', '+') );
      } else {
        setDoLogin(true)
      }
    }
  }

  useEffect(() => {
    if (login_settings === null) {
      dispatch(getLoginSettings())
    }
    checkLoggedIn()
  }, []);

  useEffect(() => {
    if (liveKasms !== null) {
      setStatus(null)
      const useId = sessiontype === 'cast' ? 'cast_config_id' : 'image_id'
      let currentImage

      if (sessiontype === 'cast') {
        currentImage = liveKasms.find(
          (kasm) => kasm[useId] === workspace_id && kasm.cast_config_id === castkey
        )
      } else {
        currentImage = liveKasms.find(
          (kasm) => kasm[useId] === workspace_id && !kasm.cast_config_id
        )  
      }
      if (currentImage) {
        setRunningImage(currentImage)
        setKasmId(currentImage.kasm_id)
        setTimeout(() => {
          setStatus(currentImage.operational_status)
        })
        
      } else {
        createWorkspace()
      }
    }
  }, [liveKasms]);

  useEffect(() => {
    if (availableKasms !== null) {
      let currentImage = availableKasms.find(
        (kasm) => kasm.image_id === workspace_id
      )
      if (currentImage) {
        setImage(currentImage)
      }
    }
  }, [availableKasms]);

  

  useEffect(() => {
    if (createdKasms && 'kasm_id' in createdKasms) {
      setKasmId(createdKasms.kasm_id)
      setStatus(createdKasms.status)
    }
  }, [createdKasms]);


  useEffect(() => {
    if (status === 'starting') {
      setTimeout(() => {
        dispatch(getUserKasms())
      }, 1000)
    }
    if (status === 'running') {
      const type = runningImage.cast_config_id ? '/cast/' + castkey : '/session/' + runningImage.kasm_id
      const redirect = pwaDetails()
      props.history.push( type + '?redirect=' + redirect.replace('#', '+') );
    }
  }, [status]);

  const pwaDetails = () => {
    let url = "/workspace/" + workspace_id.substr(0, 6) + "/#/workspace/"
    url += sessiontype + "/"
    url += workspace_id + "/"
    if (sessiontype === 'cast') {
      url += castkey + "/"
    }

    dispatch({
      type: "PWA",
      isPwa: true,
      redirectUrl: url
    })

    return url

  }

  const submitLaunch = (e) => {
    e.preventDefault()
    setDoLaunch(false)
    createWorkspace()
  }

  const defaultThumb = (e) => {
    e.target.src = "img/favicon.png";
  }

  if (doLogin) {
    return <Redirect to={{pathname: "/login", state: {from: props.location}}} />
  }
  if (doLaunch) {
    return <div className="login_box" style={{ backgroundImage: 'url("' + login_settings.launcher_background_url + '")' }}>
      
      <LaunchModal
        showCloseButton={false}
        icon={image.image_src &&
          image.image_src != "" ? (
          <img
            onError={defaultThumb}
            className="tw-rounded-full tw-self-center"
            src={image.image_src}
            onLoad={(e) => e.target.classList.add('tw-scale-100')}

          />
        ) : (
          <KasmIcon kasm={image} />
        )}
        maxWidth="sm:tw-max-w-md"
        iconBg="tw-relative tw-p-1.5 tw-rounded-full tw-bg-white"
        titleRaw={t("workspaces.Launch") + ' ' + image.friendly_name}
        description={image.description}



        open={true}
        setOpen={() => console.log('can\'t close')}
        contentRaw={<form onSubmit={submitLaunch} className="modal-inner tw-text-left tw-mt-8 tw-pb-4">
          <EgressForm data={image} setGatewayId={(value) => setGatewayId(value)} />
          <LaunchForm data={image} />
          <div className="">
            <button
              type="submit"
              className="actionbutton tw-group/button tw-mt-4 !tw-py-4 tw-bg-blue-500 !tw-shadow-[0_0_9px_rgba(0,0,0,0.15)] hover:!tw-bg-white/5 tw-border-t tw-border-0 tw-border-solid tw-border-white/25 hover:tw-border-white/10"
              style={{ cursor: "pointer" }}
            >
              {t("workspaces.Launch Session")}
            </button>
          </div>
        </form>}
      /></div>

  }
  return (<React.Fragment>{login_settings && <div className="login_box" style={{ backgroundImage: 'url("' + login_settings.launcher_background_url + '")' }}></div>}</React.Fragment>)
}